import React from "react";

import { IPropertyViewData } from "../../models/property/PropertyViewData";
import propertyActions from "../../flux/actions/PropertyActions";
import propertyInstrumentDirListStore from "../../flux/stores/property/PropertyInsDirListStore";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";

import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import AbbTableComponent from "../shared/AbbTableComponent";
import { Translation } from "react-i18next";
import triggerNotifications from "../../utilities/TriggerNotifications";
import loadingActions from "../../flux/actions/LoadingActions";
import InfiniteScroll from "react-infinite-scroll-component";
import { Icon, Spinner } from "@abb/abb-common-ux-react";
import { InputType } from "../../models/shared/IEnumTypes";
import directionListStore from "../../flux/stores/direction/ListStore";
import IDirectionData from "../../models/direction/directionData";
import directionActions from "../../flux/actions/DirectionAction";
import _ from "lodash";
import History from "../../utilities/History";

interface IViewAllState {
  list: IPropertyViewData[];
  searchValue: { key: String; value: String; type: String; sort: boolean }[];
  sortValue: string;
  sortName: string;
  sortOrder: string;
}

export default class ViewAll extends React.Component<{}, IViewAllState> {
  _mount: boolean;
  private _page: number = 1;
  private _hasMore: boolean = true;
  private _listData: any;
  private _directionList: IDirectionData[];
  constructor(props: {}) {
    super(props);

    this._mount = false;

    this.state = {
      list: [],
      sortValue: CONSTANTS.SORT_CREATEDON,
      sortName: CONSTANTS.SORT_CREATEDON,
      sortOrder: CONSTANTS.SORT_DESC_ORDER,
      searchValue: [
        { key: "Name", value: "", type: InputType.SEARCHBAR, sort: true },
        { key: "CustomId", value: "", type: InputType.SEARCHBAR, sort: true },
        { key: "Directions", value: "", type: InputType.DROPDOWN, sort: false },
        { key: "Type", value: "", type: InputType.SEARCHBAR, sort: true },
        {
          key: "InstrumentDetails",
          value: "",
          type: InputType.SEARCHBAR,
          sort: false,
        },
        { key: "Unit", value: "", type: InputType.BLANK, sort: true },
        { key: "Decimals", value: "", type: InputType.BLANK, sort: true },
        { key: "filterIcon", value: "", type: InputType.BLANK, sort: false },
      ],
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    navigationHeaderActions
      .updateHeader({
        name: CONSTANTS.MODULE_PROPERTY,
        action: CONSTANTS.VIEW_ALL,
        icon: ICONCONSTANTS.ABB_VIEW,
        goBackUrl: "",
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      })
      .then();

    this.getAll();

    propertyInstrumentDirListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._listData = [];
        if (
          state.propertyInsDirDataList.currentPage ===
            state.propertyInsDirDataList.totalPages ||
          state.propertyInsDirDataList.totalRecords === 0
        ) {
          this._hasMore = false; // it will show message
        } else {
          this._hasMore = true; // it will show spinner
        }
        this._listData = state.propertyInsDirDataList.result;
      }
    });

    directionListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._directionList = _.sortBy(state.directionDataList, "name");
    });

    directionActions.getAll().then(() => {
      this.setState({ sortOrder: CONSTANTS.SORT_DESC_ORDER });
    });
  }

  public clearFilter = () => {
    const searchValues = [
      { key: "CustomId", value: "", type: InputType.SEARCHBAR, sort: true },
      { key: "Name", value: "", type: InputType.SEARCHBAR, sort: true },
      { key: "Directions", value: "", type: InputType.DROPDOWN, sort: false },
      { key: "Type", value: "", type: InputType.SEARCHBAR, sort: true },
      {
        key: "InstrumentDetails",
        value: "",
        type: InputType.SEARCHBAR,
        sort: false,
      },
      { key: "Unit", value: "", type: InputType.BLANK, sort: true },
      { key: "Decimals", value: "", type: InputType.BLANK, sort: true },
      { key: "filterIcon", value: "", type: InputType.BLANK, sort: false },
    ];
    this.setState(
      {
        sortValue: CONSTANTS.SORT_CREATEDON,
        sortName: CONSTANTS.SORT_CREATEDON,
        sortOrder: CONSTANTS.SORT_DESC_ORDER,
        searchValue: searchValues,
      },
      () => {
        this.getAll();
      }
    );
  };

  private getAll() {
    loadingActions.setLoading(true);
    propertyActions
      .getAllPropertiesWithInstruments(
        1,
        CONSTANTS.PAGE_SIZE,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        loadingActions.setLoading(false);
        this.setState({ list: this._listData });
      })
      .catch((error) => {
        loadingActions.setLoading(false);
        triggerNotifications.errors(error.message, error.data).then();
      });
  }

  private onSearch = (name: any, value: any) => {
    const items: any = [];
    let indexNumber: number = 0;
    this.state.searchValue.forEach((item, index) => {
      if (item.key === name) {
        items.push({
          key: item.key,
          value: value,
          sort: item.sort,
          type: item.type,
        });
        indexNumber = index;
      } else {
        items.push(item);
      }
    });

    let strConcat = "";
    items.forEach((item: any) => {
      if (item.value.length) {
        strConcat = strConcat + `${item.key}:${item.value}&`;
      }
    });

    if (
      items[indexNumber].type === InputType.DROPDOWN ||
      value.length >= CONSTANTS.SEARCH_LENGTH ||
      value.length === 0
    ) {
      loadingActions.setLoading(true);
      this._page = 1;
      propertyActions
        .getAllPropertiesWithInstruments(
          1,
          CONSTANTS.PAGE_SIZE,
          this.state.sortName,
          this.state.sortOrder,
          strConcat
        )
        .then(() => {
          loadingActions.setLoading(false);
          this.setState({ list: this._listData, searchValue: items });
        });
    } else {
      this.setState({ searchValue: items });
    }
  };

  public fetchMore = () => {
    loadingActions.setLoading(true);
    this._page = this._page + 1;
    let strConcat = "";
    this.state.searchValue.forEach((item: any) => {
      if (item.value.length) {
        strConcat = strConcat + `${item.key}:${item.value}&`;
      }
    });
    propertyActions
      .getAllPropertiesWithInstruments(
        this._page,
        CONSTANTS.PAGE_SIZE,
        this.state.sortName,
        this.state.sortOrder,
        strConcat
      )
      .then(() => {
        loadingActions.setLoading(false);
        const data = [...this.state.list, ...this._listData];
        this.setState({ list: data });
      })
      .catch(() => loadingActions.setLoading(false));
  };

  public onSortHandler = (name: any, value: any, order: any) => {
    this.setState(
      {
        sortValue: value,
        sortName: name,
        sortOrder: order,
      },
      () => {
        loadingActions.setLoading(true);
        let strConcat = "";
        this.state.searchValue.forEach((item: any) => {
          if (item.value.length) {
            strConcat = strConcat + `${item.key}:${item.value}&`;
          }
        });
        this._page = 1;
        propertyActions
          .getAllPropertiesWithInstruments(
            this._page,
            CONSTANTS.PAGE_SIZE,
            this.state.sortName,
            this.state.sortOrder,
            strConcat
          )
          .then(() => {
            loadingActions.setLoading(false);
            this.setState({ list: this._listData });
          })
          .catch(() => loadingActions.setLoading(false));
      }
    );
  };

  goBack = () => {
    History.push(CONSTANTS.PROPERTY_INDEX_URL);
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-scroll">
            <div className="app-container mt-4">
              <div className="container-box rounded-sm rounded-lg submit-header-fixed ml-1 viewall-page">
                <div>
                  <Icon
                    name="abb/caret-left"
                    sizeClass="large"
                    style={{ cursor: "pointer" }}
                    onClick={this.goBack}
                  />
                </div>
                <div className="viewall-page-title">
                  <span
                    className="title font-weight-bold mt-2 ml-1"
                    style={{ verticalAlign: "super" }}
                  >
                    {t(CONSTANTS.ALL_PROPERTIES)}
                  </span>
                </div>
              </div>
              <div className="ml-1">
                <InfiniteScroll
                  dataLength={this.state?.list?.length} //This is important field to render the next data
                  next={this.fetchMore}
                  hasMore={this._hasMore}
                  loader={
                    <div>
                      <h6
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <Spinner color="blue" sizeClass="medium" />
                      </h6>
                      <div></div>
                    </div>
                  }
                  scrollThreshold={0.6}
                  scrollableTarget="scrollableDiv"
                >
                  <AbbTableComponent
                  authKey={CONSTANTS.AUTHKEY_PROPERTY}
                    columns={[
                      {
                        dataField: "name",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.MODULE_PROPERTY),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return {
                            width: "15%",
                            textAlign: "left",
                            fontWeight: "bold",
                          };
                        },
                      },
                      {
                        dataField: "customId",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.LABLE_ID),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return { width: "10%", textAlign: "right" };
                        },
                      },
                      {
                        dataField: "directions",
                        type: InputType.DROPDOWN,
                        text: t(CONSTANTS.LABEL_DIRECTION),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return { width: "10%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "type",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.TYPE),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return { width: "10%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "instrumentDetails",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.MODULE_INSTRUMENT),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return { width: "10%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "unit",
                        type: InputType.BLANK,
                        text: t(CONSTANTS.LABEL_UNIT),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return { width: "10%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "decimal",
                        type: InputType.BLANK,
                        text: t(CONSTANTS.LABEL_DECIMALS),
                        editable: false,
                        headerStyle: (colum, colIndex) => {
                          return { width: "10%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "filterIcon",
                        type: InputType.BLANK,
                        text: "",
                        editable: false,
                        style: { width: "5%" },
                        headerStyle: (colum, colIndex) => {
                          return { width: "5%", textAlign: "left" };
                        },
                      },
                    ]}
                    list={this.state.list}
                    searchValue={this.state.searchValue}
                    onSearchHandler={this.onSearch}
                    sortOrder={this.state.sortOrder}
                    sortValue={this.state.sortValue}
                    onSortHandler={this.onSortHandler}
                    dropDownData={this._directionList}
                    clearFilter={this.clearFilter}
                    select={false}
                    isFixedColumn={false}
                    isEditable={false}
                    delete={false}
                    isRowClass={"property-normal-row"}
                    view={true}
                    viewAllPage={true}
                    redirectBaseUrl={CONSTANTS.MODULE_PROPERTY}
                    isTitle={
                      <div className="float-left ml-1">
                        <div className="box-circle">
                          <p className="box-circle-text"> 1 </p>
                        </div>
                        <div className="ml-4">
                          <p className="sidebar-main-title font-weight-bold ml-2">
                            {t(CONSTANTS.MODULE_PROPERTY)}
                          </p>
                        </div>
                      </div>
                    }
                  />
                </InfiniteScroll>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
